// ABOUTME: The day cells of a date picker's month grid: the tail of the previous month, the month itself and
// ABOUTME: the head of the next, Monday first, every date at local noon so no time-zone shift moves a day.

export interface MonthGridDay {
  date: Date
  isCurrentMonth: boolean
}

export const monthGridDays = (month: Date): MonthGridDay[] => {
  const year = month.getFullYear()
  const monthIndex = month.getMonth()
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate()
  // Weekday of the 1st with Monday as 0.
  const leading = (new Date(year, monthIndex, 1).getDay() + 6) % 7
  const prevMonthLastDay = new Date(year, monthIndex, 0).getDate()
  const trailing = Math.ceil((daysInMonth + leading) / 7) * 7 - daysInMonth - leading

  const days: MonthGridDay[] = []
  for (let i = leading - 1; i >= 0; i--) {
    days.push({ date: new Date(year, monthIndex - 1, prevMonthLastDay - i, 12, 0, 0), isCurrentMonth: false })
  }
  for (let day = 1; day <= daysInMonth; day++) {
    days.push({ date: new Date(year, monthIndex, day, 12, 0, 0), isCurrentMonth: true })
  }
  for (let day = 1; day <= trailing; day++) {
    days.push({ date: new Date(year, monthIndex + 1, day, 12, 0, 0), isCurrentMonth: false })
  }
  return days
}
